import useQueryParam from "./queryParam";

const useBurgerMenu = () => {
  const params = useQueryParam('burgermenu');
  const isMenuOpen = params.get() === '1';
  const close = () => params.remove();
  const open = () => params.set('1');
  const toggleMenu = isMenuOpen ? close : open;
  return { isMenuOpen, toggleMenu, close };
}

export default useBurgerMenu;